module.exports = __webpack_public_path__ + "img/general-5.2.be72b578.svg";